module.exports = __webpack_public_path__ + "static/img/6.1.8646e2f9.png";